var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg07BmwSpeedometer5YcFe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    height: "356px",
    width: "290px",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "corridor",
    x: 60,
    y: 293,
    opacity: 0.2,
    fill: "#3C6BAD",
    width: 163,
    height: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "baseline-2",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 262.5,
    x2: 222,
    y2: 262.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilterZz",
    filterUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilterZz)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 76,
    width: 9,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y_1_",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M66,297h9v30h-9V297z M102,327h9v-30h-9V327z M137,327h9v-30h-9V327z M172,327h9v-30h-9V327z M66,256h9V104h-9 V256z M102,256h9V90h-9V256z M137,256h9V76h-9V256z M172,82v174h9V82H172z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y",
    fill: "#3C6BAD",
    d: "M207,297h9v30h-9V297z M207,80v176h9V80H207z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "fe-quote-marge-pin_1_",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,298 227,287 290,287  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "fe-kosten-pin",
    fill: "none",
    stroke: "#3C6BAD",
    strokeMiterlimit: 10,
    points: "215.5,81 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    id: "corridor-min_2_",
    transform: "matrix(1 0 0 1 225 304.2618)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "6px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    id: "corridor-max_1_",
    transform: "matrix(1 0 0 1 225 295.2618)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "6px"
  }, "5,5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-fe-qoute",
    transform: "matrix(1 0 0 1 282.0972 282.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    id: "head-fe-quote_1_",
    transform: "matrix(1 0 0 1 16.1592 309.7393)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Research and"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.559,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "development"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.332,
    y: 16.8,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "quote in %")), /*#__PURE__*/React.createElement("text", {
    id: "head-strategische-zielrahmen_1_",
    transform: "matrix(1 0 0 1 10.9194 284.5381)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Strategic target"), /*#__PURE__*/React.createElement("tspan", {
    x: -0.075,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "framework in %")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-fe-kosten",
    transform: "matrix(1 0 0 1 254.2212 31.5234)",
    fill: "#3C6BAD",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "6,419"), /*#__PURE__*/React.createElement("text", {
    id: "head-fe-kosten_1_",
    transform: "matrix(1 0 0 1 21.1255 81.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "F&amp;E Kosten"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.547,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Mio. \u20AC")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07BmwSpeedometer5YcFe);
export default __webpack_public_path__ + "static/media/07_BMW_speedometer-5YC-fe.156c2bdd.svg";
export { ForwardRef as ReactComponent };